import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarPrograma } from "../../services/programa.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";

export const ProgramaCard = ({ programa = {}, index, onDelete }) => {
  const navigate = useNavigate();

  const { idPrograma, nombre, duracion, totalPrecio } = programa;

  const handleDelete = () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarPrograma(idPrograma);
            showDeletedAlert({
              callback: () => onDelete?.(idPrograma),
            });
          } catch (error) {
            console.error("Error al eliminar el programa:", error);
            showErrorAlert();
          }
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => navigate(`/programas/actualizar/${idPrograma}`),
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 text-sm [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{nombre || "N/D"}</td>
      <td className="border-r border-slate-200 border-t">{duracion || "N/D"}</td>
      <td className="border-r border-slate-200 border-t">
        {totalPrecio ? `Bs. ${totalPrecio}` : "N/D"}
      </td>
      <td className="border-slate-200 border-t">
        <div className="flex justify-start gap-4">
          <button
            onClick={handleUpdate}
            className="bg-green-500 p-1 rounded-md text-white"
            title="Editar"
          >
            <EditIcon className="w-5 h-5" />
          </button>
          <button
            onClick={handleDelete}
            className="bg-red-500 p-1 rounded-md text-white"
            title="Eliminar"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
